export default __webpack_public_path__ + "static/recess-logo-50e241cef87dbc376bc2f74c19228bbc.png";